import React from 'react'

export function getAccessibleText(node: React.ReactNode): string {
  if (node == null || typeof node === 'boolean') return ''
  if (typeof node === 'string' || typeof node === 'number' || typeof node === 'bigint') {
    return String(node)
  }
  if (Array.isArray(node)) {
    return node.map(getAccessibleText).filter(Boolean).join(' ')
  }
  if (React.isValidElement<{ children?: React.ReactNode }>(node)) {
    return getAccessibleText(node.props.children)
  }
  return ''
}
